import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'htmlStyleInjector',
    standalone: false
})
export class HtmlStyleInjectorPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(html: string, style: string): SafeHtml {
    const taggedStyle = `<style>${style}</style>`;
    return this.sanitizer.bypassSecurityTrustHtml(taggedStyle + html);
  }
}